import React from 'react';

import { Box, Typography } from '@mui/material';

import { IEmptyListViewProp } from 'src/components/common/types/modalTypes';

const NoDataView: React.FC<IEmptyListViewProp> = ({
	message,
}: IEmptyListViewProp): React.JSX.Element => (
	<Box
		sx={{
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			paddingTop: '3rem',
			paddingBottom: '2rem',
			borderRadius: '1rem',
			fontFamily: 'Roboto',
			gap: 3,
		}}
	>
		<img src='/EmptyList.svg' alt='empty-list-view' />
		<Typography color='text.secondary'>{message}</Typography>
	</Box>
);

export default NoDataView;
